import { useCallback, useEffect } from "react";
import { removeObject } from "find-and";

import { useProjectInfo, useProjectUpdate } from "ducks/project/hooks";
import { deleteResources } from "../../resources/resources";
import { tableRemove } from "../../resources/tables";

export const useDeleteLayer = () => {
  const [resourcesMutation] = deleteResources.use();
  const [{ name, content }] = useProjectInfo();
  const [deleteTableMutation] = tableRemove.use();
  const mutation = useProjectUpdate();

  const deleteLayerFromCatalog = useCallback(
    (layer: string, table?: string) => {
      if (table) {
        return resourcesMutation({ input: { layers: [layer], tables: [table] } });
      }

      return resourcesMutation({ input: { layers: [layer] } });
    },
    [resourcesMutation],
  );

  const deleteLayerFromProject = useCallback(
    (layer: string) =>
      mutation({
        name,
        content: {
          ...content,
          items: removeObject(content.items, { name: layer }),
        },
      }),
    [mutation, name, content],
  );

  const deleteTable = useCallback(
    (tableName: string) => {
      return deleteTableMutation({ input: tableName });
    },
    [deleteTableMutation],
  );

  return { deleteLayerFromCatalog, deleteLayerFromProject, deleteTable };
};

export const useDeleteLayerWithTableEffect = (trigger: boolean, layerName?: string, tableName?: string) => {
  const { deleteLayerFromCatalog, deleteLayerFromProject, deleteTable } = useDeleteLayer();

  useEffect(() => {
    if (trigger && layerName) {
      deleteLayerFromProject(layerName);
      tableName && deleteLayerFromCatalog(layerName, tableName);
      tableName && deleteTable(tableName);
    }
  }, [trigger, layerName, tableName]);
};
